<template>
  <px-custom-dialog
    transition="fadet"
    :width="dialogWidth"
    v-model="dialog"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>
    <template v-slot:title>
      Editar vínculo
    </template>
    <div class="mt-3">
      <v-row dense>
        <v-col cols="12">
          <v-textarea
            outlined
            auto-grow
            class="rounded-tag-small"
            label="Observações internas"
            counter="2000"
            rows="2"
            v-model="observacaoInterna"
          />
        </v-col>
      </v-row>
    </div>
    <template v-slot:actions>
      <v-btn class="rounded-tag-small normal-btn-text elevation-0"
             color="primary"
             :loading="loading"
             @click="onClickAtualizar">
        Salvar
      </v-btn>
      <v-btn class="rounded-tag-small normal-btn-text elevation-0"
             :disabled="loading"
             @click="onCloseDialog">
        Fechar
      </v-btn>
    </template>
  </px-custom-dialog>
</template>

<script>
import NotasFiscaisCompraLinkService
  from '@/modules/notas-fiscais/notas-fiscais-compra-link-service';

export default {
  props: {
    notaFiscalVinculo: {
      type: Object,
      required: true,
    },
    compra: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      observacaoInterna: null,
    };
  },
  computed: {
    isSmall() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    dialogWidth() {
      return this.isSmall ? '95%' : '900px';
    },
  },
  methods: {
    onCloseDialog() {
      this.dialog = false;
    },
    onClickAtualizar() {
      this.loading = true;
      const payload = {
        id: this.notaFiscalVinculo.id,
        observacaoInterna: this.observacaoInterna,
      };
      NotasFiscaisCompraLinkService.updateObservacao(this.notaFiscalVinculo.compra.id,
        this.notaFiscalVinculo.id, payload)
        .then(({ data }) => {
          this.$emit('change', data);
          this.$toast.success('Observação atualizada');
          this.onCloseDialog();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    dialog(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (newValue) {
        this.observacaoInterna = this.notaFiscalVinculo.observacaoInterna;
      }
    },
  },
};
</script>
